export default "__VITE_ASSET__BubtxqVv__"